import { useState } from 'react';
import type { AppRole, User } from '@casetrace/shared';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useAdminActions } from '../../hooks/use-admin-actions';

const SELECT_CLASS =
  'rounded-md border border-white/[0.1] bg-[#1a1b23] px-2 py-1.5 text-xs text-[#ededf0]';

interface AdminUserRowProps {
  user: User;
}

export function AdminUserRow({ user }: AdminUserRowProps) {
  const { updateUser } = useAdminActions();
  const [displayName, setDisplayName] = useState(user.displayName);
  const [appRole, setAppRole] = useState<AppRole>(user.appRole);
  const [disabled, setDisabled] = useState(user.disabled);
  const hasChanges =
    displayName !== user.displayName || appRole !== user.appRole || disabled !== user.disabled;

  async function handleSave() {
    await updateUser.mutateAsync({
      userId: user.id,
      displayName,
      appRole,
      disabled,
    });
  }

  return (
    <div className="rounded-md bg-white/[0.03] px-3 py-3">
      <div className="space-y-3">
        <div>
          <p className="text-[11px] text-text-tertiary">{user.email}</p>
          <Input
            id={`admin-user-name-${user.id}`}
            value={displayName}
            onChange={(event) => setDisplayName(event.target.value)}
            className="mt-1 py-1.5 text-xs"
          />
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <select
            aria-label="App-rolle"
            className={SELECT_CLASS}
            value={appRole}
            onChange={(event) => setAppRole(event.target.value as AppRole)}
          >
            <option value="user">Bruker</option>
            <option value="admin">Admin</option>
          </select>
          <label className="flex items-center gap-2 text-xs text-text-secondary">
            <input
              type="checkbox"
              checked={disabled}
              onChange={(event) => setDisabled(event.target.checked)}
            />
            Deaktivert
          </label>
          <Button
            type="button"
            variant="outline"
            className="ml-auto px-3 py-1.5 text-xs"
            disabled={!hasChanges || updateUser.isPending}
            onClick={() => void handleSave()}
          >
            Lagre
          </Button>
        </div>
      </div>
      {updateUser.isError && (
        <p className="mt-2 text-xs text-danger/80">Kunne ikke lagre bruker.</p>
      )}
    </div>
  );
}
